import React from 'react';
import { hasSomeActivityBooked } from 'Components/utils/booking/bookingUtils';
import { t } from 'Src/i18n';
import { UpsellCard } from 'Components/frameworks/upsell-card/UpsellCard';
type Props = {
  className?: string;
  category: ActivitiesCategoryEntity;
  hasOnlineBookableTotal?: boolean;
  onClick?: () => void;
  url?: string;
};
export const UpsellActivitiesCard = ({
  category,
  className,
  hasOnlineBookableTotal = false,
  onClick,
  url,
}: Props) => {
  const onlineBookableActivitiesCount = category?.onlineBookableCount || 0;
  const totalActivities = hasOnlineBookableTotal
    ? onlineBookableActivitiesCount
    : (category?.activitiesCounters?.included || 0) + (category?.activitiesCounters?.onDemand || 0);
  return (
    <UpsellCard
      className={className}
      imageUrl={category.images?.[0]}
      key={category.id}
      isChecked={hasSomeActivityBooked(category)}
      label={category.name || t('booking.activities.otherActivities')}
      onClick={onClick}
      text={t(
        totalActivities > 1 ? 'common.activities.counters._n' : 'common.activities.counters._1',
        {
          count: totalActivities,
        },
      )}
      price={category.bestPrice?.formattedValue}
      url={url}
    />
  );
};
